import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { Text } from 'apps/auth/components/common/Text/Text';
import { URL_IMAGES_ICONS } from 'apps/auth/constants/UrlConstants';
import { useThemeDetector } from 'apps/auth/hooks/theme';

const PoweredByContainer = styled.div`
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        margin-left: 6px;
    }
`;

const PreCheckPoweredBy = (props) => {
    const { theme } = useThemeDetector();

    return (
        <PoweredByContainer>
            <Text size="tag">{props.poweredBy}</Text>
            <img src={`${URL_IMAGES_ICONS}/${props.img}${theme === 'dark' ? '-white' : ''}.svg`} alt={props.alt} />
        </PoweredByContainer>
    );
};

PreCheckPoweredBy.propTypes = {
    poweredBy: PropTypes.string,
    img: PropTypes.string,
    alt: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        poweredBy: state.messages.pageMessages.poweredBy,
    };
};
export default connect(mapStateToProps, null)(PreCheckPoweredBy);
